exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2pV4eaG4u-BMDO67_NpQdw {\n  margin-bottom: 16px;\n}\n\n._1Phzt_ptV5v8gWyP7MZqY {\n  margin-bottom: 12px;\n}\n\n._3tL3PqxPkFFN7StybNITEO {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 4px;\n  color: var(--primary-text-color);\n}\n\n._2MuKqR-QYAC7yy8NI1RcZZ {\n  font-size: 12px;\n  color: var(--secondary-text-color);\n  margin: 0;\n}\n\n._26UizTcd7034sTLp2mJ25R {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n._3NQkyu0F6yjfAhQbHhAzdo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n._27vX9AM0-LnjD7aPlOx7ww {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--primary-text-color);\n  white-space: nowrap;\n  min-width: 140px;\n}\n\n._1wf9sXnLDg4ZaBG7SZhFF- {\n  max-width: 400px;\n  flex: 1;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_2pV4eaG4u-BMDO67_NpQdw",
	"header": "_1Phzt_ptV5v8gWyP7MZqY",
	"title": "_3tL3PqxPkFFN7StybNITEO",
	"description": "_2MuKqR-QYAC7yy8NI1RcZZ",
	"rows": "_26UizTcd7034sTLp2mJ25R",
	"selectRow": "_3NQkyu0F6yjfAhQbHhAzdo",
	"selectLabel": "_27vX9AM0-LnjD7aPlOx7ww",
	"selectWrapper": "_1wf9sXnLDg4ZaBG7SZhFF-"
};